export enum ItemType {
  Base = 'Base',
  CustomMixed = 'CustomMixed',
  ReadyMixed = 'ReadyMixed',
  KMAT = 'KMAT',
  None = 'None',
  Unknown = 'Unknown',
}
